import angular from 'angular';
import _ from 'lodash-es';
import controller from './datetime.controller';
import template from './datetime.html';
import './datetime.scss';
import DatetimeComponent from './datetime.component';

const datetimeConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('datetime', {
		title:      'Date / Time',
		template,
		/**
		 * @param {string | Date} data
		 * @param {any} options
		 * @returns {string}
		 */
		tableView(data, options) {
			// eslint-disable-next-line no-param-reassign
			data = _.isDate(data) ? data.toISOString() : data;
			return options.$interpolate(`<span>{{ "${data}" | date: "${options.component.format}" }}</span>`)();
		},
		group:      'advanced',
		onEdit:     /* @ngInject */ (/** @type {any} */ $scope) => {
			// FOR-34 - Update 12hr time display in the field, not only time picker.
			$scope.$watch('component.timePicker.showMeridian', (/** @type {any} */ value) => {
				const oldValue = value ? 'HH' : 'hh';
				const newValue = value ? 'hh' : 'HH';

				if ($scope.component.enableTime) {
					$scope.component.format = $scope.component.format.toString().replace(oldValue, newValue);
				}
			});

			$scope.setFormat = () => {
				let stdFormatDateTime = 'yyyy-MM-dd HH:mm';
				const stdFormatDate = 'yyyy-MM-dd';
				let stdFormatTime = 'HH:mm';
				if ($scope.component.timePicker.showMeridian) {
					stdFormatDateTime = 'yyyy-MM-dd hh:mm';
					stdFormatTime = 'hh:mm';
				}
				const stdFormats = new Set([
					stdFormatDateTime,
					stdFormatDate,
					stdFormatTime,
				]);

				if (
					$scope.component.enableDate
					&& $scope.component.enableTime
					&& stdFormats.has($scope.component.format)
				) {
					$scope.component.format = stdFormatDateTime;
				}
				else if (
					$scope.component.enableDate
					&& !$scope.component.enableTime
					&& stdFormats.has($scope.component.format)
				) {
					$scope.component.format = stdFormatDate;
				}
				else if (
					!$scope.component.enableDate
					&& $scope.component.enableTime
					&& stdFormats.has($scope.component.format)
				) {
					$scope.component.format = stdFormatTime;
				}
			};
			$scope.startingDays = [
				'Sunday',
				'Monday',
				'Tuesday',
				'Wednesday',
				'Thursday',
				'Friday',
				'Saturday',
			];
			$scope.modes = [
				{
					name:  'day',
					label: 'Day',
				},
				{
					name:  'month',
					label: 'Month',
				},
				{
					name:  'year',
					label: 'Year',
				},
			];
		},
		icon:          'fa fa-calendar-plus-o',
		views:        [
			{
				name:     'Display',
				template: 'kform/components/datetime/display.html',
			},
			{
				name:     'Data',
				template: 'kform/components/datetime/data.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/common/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name:     'Events',
				template: 'kform/components/common/events.html',
			},

		],
		controller,
		children:   false,
		selectable: true,
		settings:   new DatetimeComponent(),
	});
};

export default angular.module('app').config(datetimeConfig);
